/** «Ответить в треде (Ctrl+Shift+T)» → текст и клавиши для отдельных плашек. */
export function splitHint(title: string): { text: string; keys: string[] } {
  const match = /^(.*?)\s*\(((?:Ctrl|Alt|Shift|Enter|Esc|⌘)[^()]*|[A-Z])\)$/.exec(title.trim());
  if (match === null) return { text: title.trim(), keys: [] };
  return { text: match[1] ?? '', keys: (match[2] ?? '').split('+').map((k) => k.trim()).filter((k) => k !== '') };
}
